import axios, { AxiosPromise, CancelTokenSource } from 'axios';
import httpClient from '../../common/api/httpClient';
import urlRoute from '../../common/service/urlRoute';
import { API } from '../constants/api';
import IDeal from '../../common/model/IDeal';
import { IBasketInitV3Request } from '../../gqlCommon/model/IBasketInitV3Request';

export interface IBasketInitRequest {
  vehicleId: string;
  vehicleAccessories: string[];
  vehicleAccessoryPacks: string[];
  vehicleServicePlan: string | null;
  dealerId: string | null;
  postcode: string | null;
  configurationSourceUrl: string;
}

let dealConfigureSource: null | CancelTokenSource = null;

const basketApi = {
  init: (initRequest: IBasketInitRequest): AxiosPromise<IDeal> => {
    return httpClient.throttleCall('basketApi:init', ({ cancelToken }) => {
      return httpClient.post<IDeal>(urlRoute.createUrl(API.BASKET_INIT), initRequest, { cancelToken });
    });
  },
  preInitBasket: (requestData: IBasketInitV3Request): AxiosPromise<IDeal> => {
    return httpClient.throttleCall('basketApi:init-from-30', ({ cancelToken }) => {
      return httpClient.post<IDeal>(urlRoute.createUrl(API.BASKET_INIT_V3), requestData, { cancelToken });
    });
  },
  preInitBasketComplex: (requestData: IBasketInitV3Request): AxiosPromise<IDeal> => {
    return httpClient.throttleCall('basketApi:init-from-30-cm', ({ cancelToken }) => {
      return httpClient.post<IDeal>(urlRoute.createUrl(API.BASKET_INIT_V3_COMPLEX), requestData, { cancelToken });
    });
  },
  selectCar: (carId: string, configurationSourceUrl: string): AxiosPromise<IDeal> => {
    return httpClient.post(urlRoute.createUrl(API.BASKET_SELECT_CAR), { carId, configurationSourceUrl });
  },
  selectInterior: (interiorColorId: string, configurationSourceUrl: string): AxiosPromise<IDeal> => {
    return httpClient.post(urlRoute.createUrl(API.BASKET_SELECT_INTERIOR), { interiorColorId, configurationSourceUrl });
  },
  selectExterior: (exteriorColorId: string, configurationSourceUrl: string): AxiosPromise<IDeal> => {
    return httpClient.post(urlRoute.createUrl(API.BASKET_SELECT_EXTERIOR), { exteriorColorId, configurationSourceUrl });
  },
  selectStockCar: (initRequest: IBasketInitRequest): AxiosPromise<IDeal> => {
    if (dealConfigureSource) {
      dealConfigureSource.cancel();
    }

    dealConfigureSource = axios.CancelToken.source();

    return httpClient.post(urlRoute.createUrl(API.BASKET_SELECT_STOCK_CAR), initRequest, {
      cancelToken: dealConfigureSource.token,
    });
  },
};

export default basketApi;
